import {toast} from 'react-toastify';
import LocalDataService from './LocalDataService';

class ApiService {
    constructor() {
        this.apiBase = 'https://ft.motubizhi.com'; // 服务器地址
        // 全局引用，用于存储userProfileRef
        this.userProfileRef = null;
    }

    // 设置userProfileRef的方法
    setUserProfileRef(ref) {
        this.userProfileRef = ref;
    }

    // 通用的请求方法
    async request(url, method, data) {
        var accessToken = LocalDataService.load_login_data();
        const requestOptions = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'accessToken': accessToken,
            },
            body: JSON.stringify(data)
        };

        try {
            const response = await fetch(url, requestOptions);
            const responseData = await response.json();
            if (!response.ok) {
                throw {status: response.status, data: JSON.stringify(responseData)};
            }
            return responseData; // 返回解析后的JSON对象
        } catch (error) {
            // 检查是否是500错误（登录态失效）
            if (error && error.status === 500 && error.data && error.data.indexOf && error.data.indexOf('token') != -1) {
                // 清除本地登录信息
                LocalDataService.set_user_data(null);
                LocalDataService.set_login_data(null);


                // 显示错误提示
                toast.error('登录已过期，请重新登录');
            } else {
                // 其他错误，如果不是获取命令列表的请求，则显示错误提示

                toast.error(`请求错误：${error.data || JSON.stringify(error)}`);

            }

            throw error; // 将错误抛出，使得调用者能够处理它
        }
    }  // 通用的请求方法
    // 通用的文件请求方法
    async requestFile(url, method, formData) {
        var accessToken = LocalDataService.load_login_data();
        const requestOptions = {
            method: method,
            headers: {
                'accept': 'application/json',
                'accessToken': accessToken,
            },
            body: formData
        };

        try {
            const response = await fetch(url, requestOptions);
            const responseData = await response.json();
            if (!response.ok) {
                throw {status: response.status, data: JSON.stringify(responseData)};
            }
            return responseData; // 返回解析后的JSON对象
        } catch (error) {
            // 检查是否是500错误（登录态失效）
            if (error && error.status === 500 && error.data && error.data.indexOf && error.data.indexOf('token') != -1) {
                // 清除本地登录信息
                LocalDataService.set_user_data(null);
                LocalDataService.set_login_data(null);


                // 显示错误提示
                toast.error('登录已过期，请重新登录');
            } else {
                // 其他错误，如果不是获取命令列表的请求，则显示错误提示

                toast.error(`请求错误：${error.data || JSON.stringify(error)}`);

            }

            throw error; // 将错误抛出，使得调用者能够处理它
        }
    }

    //验证码登陆
    login_message(phone, loginType, code) {
        return this.request(`${this.apiBase}/user/login`, 'POST', {phone, loginType, code});
    }

    //手机号绑定登陆
    binding_mobile(mobile, code) {
        return this.request(`${this.apiBase}/user/bindingMobile`, 'POST', {mobile, code});
    }


    //获取用户信息
    get_user_info(token) {
        return this.request(`${this.apiBase}/user/mine`, 'GET');
    }

    //获取验证码
    get_message_code(mobile) {
        return this.request(`${this.apiBase}/user/smsCode`, 'POST', {mobile});
    }


    //获取公众号登录链接
    get_qrcode() {
        return this.request(`${this.apiBase}/user/wx/qr`, 'GET');
    }

    //获取公众号登录链接
    check_qrcode_status(sceneId) {
        return this.request(`${this.apiBase}/user/wx/qr/status?sceneId=` + sceneId, 'GET');
    }

    //创建api_token
    create_api_token() {
        return this.request(`${this.apiBase}/user/token`, 'POST');
    }

    //获取api_token列表
    get_api_token_list() {
        return this.request(`${this.apiBase}/user/tokens`, 'GET');
    }

    //删除api_token
    del_api_token(token) {
        return this.request(`${this.apiBase}/user/token`, 'DELETE', {token});
    }


    //获取智能体列表
    getAgentList(pageSize, pageNum) {
        return this.request(`${this.apiBase}/ft/agents?pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }

    //获取智能体详情
    getAgentInfo(id) {
        return this.request(`${this.apiBase}/ft/agent?id=` + id, 'GET');
    }


    //获取扣子空间列表
    getCozeSpaceList() {
        return this.request(`${this.apiBase}/ft/coze/spaces`, 'GET');
    }


    //绑定扣子空间
    bindCozeSpace(url) {
        return this.request(`${this.apiBase}/ft/coze/space`, 'POST', {url});
    }


    //删除扣子空间 空间id，非扣子ID
    delCozeSpace(id) {
        return this.request(`${this.apiBase}/ft/coze/space`, 'DELETE', {id});
    }


    //复制智能体列表
    getAgentCopyList(pageSize, pageNum) {
        return this.request(`${this.apiBase}/ft/coze/agent/copys?pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }


    //迁移智能体
    moveAgentList(agentIds, cozeSpaceId) {
        return this.request(`${this.apiBase}/ft/coze/agent/copy`, 'POST', {agentIds, cozeSpaceId});
    }

    //扣子上传文件
    uploadCozeFile(file, flowId) {
        // 创建FormData对象
        const formData = new FormData();
        formData.append('file', file);
        formData.append('flowId', flowId);
        return this.requestFile(`${this.apiBase}/ft/coze/upload`, 'POST', formData);
    }


    //火山上传文件
    uploadHsFile(suffix) {
        return this.request(`${this.apiBase}/task/hs/token`, 'POST', {suffix});
    }

    //执行工作流
    executeWorkflow(flowId, inputs) {
        return this.request(`${this.apiBase}/ft/coze/flow/run`, 'POST', {flowId, inputs});
    }


    //工作流执行结果
    executeWorkflowResult(id) {
        return this.request(`${this.apiBase}/ft/coze/flow/run/result?id=` + id, 'GET',);
    }

    //工作流执行结果列表
    executeWorkflowResultList(pageSize, pageNum) {
        return this.request(`${this.apiBase}/ft/coze/flow/run/list?pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET',);
    }

    //执行工作流云渲染
    executeWorkflowVideoGen(flowTaskId) {
        return this.request(`${this.apiBase}/ft/flow/videogen`, 'POST', {flowTaskId});
    }


    //智能体执行结果列表
    executeAgentResultList(pageSize, pageNum) {
        return this.request(`${this.apiBase}/ft/agent/run/history?pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET',);
    }

    //工作流详情
    getWorkflowInfo(id) {
        return this.request(`${this.apiBase}/ft/flow?id=` + id, 'GET',);
    }
    //工作流列表
    getWorkflowList(pageSize, pageNum,tagId) {
        return this.request(`${this.apiBase}/ft/flows?tagId=` + tagId+ `&pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET',);
    }

    getWorkflowTags(){ return this.request(`${this.apiBase}/ft/flow/tags`, 'GET',);};

    //商品列表 如会员，积分等
    productList(goodType) {
        return this.request(`${this.apiBase}/order/items?goodType=` + goodType, 'GET',);
    }

    /**
     * 创建订单
     * @param payItem 商品ID
     * @param itemType 商品类型，有商品id，不用给
     * @param inviteCode 邀请码
     * @param couponId 优惠券ID
     * @param total 购买数量
     * @param payType 支付方式   枚举值
     * alipay 支付宝
     * wx 微信
     * wx_h5 微信h5
     * wx_native 微信扫码
     * wx_mini 微信小程序
     * wx_js 微信js
     * ios ios支付
     * alipay_agreement 支付宝签约
     * alipay_h5 支付宝h5
     * alipay_page 支付宝页面
     * @returns {Promise<any|undefined>}
     */
    createOrder(payItem, itemType, inviteCode, couponId, total, payType,appid) {
        return this.request(`${this.apiBase}/order/create`, 'POST', {
            payItem,
            itemType,
            inviteCode,
            couponId,
            total,
            payType,
            appid,
        });
    }

    /**
     * 订单信息
     * @param orderId 创建订单的ID
     * @returns {Promise<any|undefined>}
     */
    orderInfo(orderId) {
        return this.request(`${this.apiBase}/order/info?orderId=` + orderId, 'GET',);
    }

    /**
     * 会员兑换码
     * @param code
     * @returns {Promise<any|undefined>}
     */
    vipCodeChange(code) {
        return this.request(`${this.apiBase}/user/vipChange`, 'POST', {code});
    }

    /**
     * 积分记录
     * @param pageSize
     * @param pageNum
     * @returns {Promise<any|undefined>}
     */
    pointRecords(pageSize, pageNum) {
        return this.request(`${this.apiBase}/user/points/records?pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }

    /**
     * 积分记录
     * @param pageSize
     * @param pageNum
     * @returns {Promise<any|undefined>}
     */
    orderRecords(goodType, pageSize, pageNum) {
        return this.request(`${this.apiBase}/order/list?goodType=` + goodType + `&pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }

    /**
     * 收费标准
     * @returns {Promise<any|undefined>}
     */
    nodeCostList() {
        return this.request(`${this.apiBase}/ft/components`, 'GET');
    }

    /**
     * 课程标签
     * @returns {Promise<any|undefined>}
     */
    getCourseTags() {
        return this.request(`${this.apiBase}/ft/tutorialTags`, 'GET');
    }


    //获取课程列表
    getCourseList(tagid, pageSize, pageNum) {
        return this.request(`${this.apiBase}/ft/tutorials?tagid=` + tagid + `&pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }

    //获取课程详情
    getCourseInfo(id) {
        return this.request(`${this.apiBase}/ft/tutorial?id=` + id, 'GET');
    }

    //用户分销的信息
    getUserInviteInfo() {
        return this.request(`${this.apiBase}/distribution/user`, 'GET');
    }

    /**
     * 分销的下级用户
     * @param g 级别，1 已经代理产生的记录，2 二级代理产生的记录。
     * @returns {Promise<any|undefined>}
     */
    getInviteUserList(g, pageSize, pageNum) {
        return this.request(`${this.apiBase}/distribution/users?g=` + g + `&pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }

    /**
     * 保存用户上级邀请码
     * @param inviteCode
     * @returns {Promise<any|undefined>}
     */
    saveUserSuperiorInviteCode(inviteCode) {
        return this.request(`${this.apiBase}/distribution/userSave`, 'POST', {inviteCode});
    }

    /**
     * 获取签约信息以及提现账号信息
     * @returns {Promise<any|undefined>}
     */
    getUserSignInfo() {
        return this.request(`${this.apiBase}/distribution/account`, 'GET',);
    }

    /**
     * 保存签约信息
     * @param realName 姓名
     * @param idNo 身份证
     * @returns {Promise<any|undefined>}
     */
    saveUserSignInfo(realName, idNo) {
        return this.request(`${this.apiBase}/distribution/sign`, 'POST', {realName, idNo});
    }

    /**
     * 保存提现账号信息
     * @param account
     * @param mobile
     * @param channel 0 银行卡，1 支付宝，2 微信
     * @param remark 备注
     * @returns {Promise<any|undefined>}
     */
    saveUserWithdrawAccountInfo(account, mobile, channel) {
        return this.request(`${this.apiBase}/distribution/account`, 'POST', {account, mobile, channel});
    }

    /**
     * 提交提现申请
     * @param amount
     * @param channel
     * @param account
     * @param mobile
     * @returns {Promise<any|undefined>}
     */
    submitUserWithdrawInfo(amount, channel, account, mobile) {
        return this.request(`${this.apiBase}/distribution/withdraw`, 'POST', {amount, channel, account, mobile});
    }

    /**
     * 提现记录
     * @param pageSize
     * @param pageNum
     * @returns {Promise<any|undefined>}
     */
    getUserWithdrawHistory(pageSize, pageNum) {
        return this.request(`${this.apiBase}/distribution/withdraws?pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }

    /**
     * 分成记录
     * @param pageSize
     * @param pageNum
     * @returns {Promise<any|undefined>}
     */
    getUserAmountHistory(pageSize, pageNum) {
        return this.request(`${this.apiBase}/distribution/records?g=1&pageSize=` + pageSize + '&pageNum=' + pageNum, 'GET');
    }

    /**
     * 签到
     * @returns {Promise<any|undefined>}
     */
    check_in() {
        return this.request(`${this.apiBase}/user/daily/sign`, 'POST');
    }

    /**
     * 最近签到
     * @returns {Promise<any|undefined>}
     */
    get_check_in_history() {
        return this.request(`${this.apiBase}/user/daily/signinLatest`, 'GET');
    }


}

export default ApiService;
